import { call, put, takeEvery } from "redux-saga/effects";

import {
  USER_LIST,
  USER_FULLLIST,
  USER_FILTER,
  USER_CREATE,
  USER_UPDATE,
  USER_DELETE,
  USER_PERMISSION
} from "./actionTypes";

import {
 userListSuccess,
 userFullListSuccess,
 userCreateSuccess,
 userUpdateSuccess,
 userDeleteSuccess,
 userRequestFailed,
 userPermissionSuccess,
} from "./actions";

import {
  getUserList,
  getUserFullList,
  getUserFilter,
  postUserCreate,
  patchUserUpdate,
  deleteUser,
  postPermissionToUser,
} from "../../../helpers/backend";

function*userListSaga() {
  console.log("Trayendo lista de user...");
  try {
    const response = yield call(getUserList);
    if (response.status === 200) {
      yield put(userListSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}
function*userFullListSaga() {
  console.log("Trayendo lista de FullList user...");
  try {
    const response = yield call(getUserFullList);
    if (response.status === 200) {
      yield put(userFullListSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function*userCreateSaga({ payload:user }) {
  console.log("Creando nuevo user...");
  try {
    const response = yield call(postUserCreate,user);
    if (response.status === 201) {
      yield put(userCreateSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function*userFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getUserFilter, { changeUrl });
    if (response.status === 200) {
      yield put(userListSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function*userUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos del USER...");
  try {
    const response = yield call(patchUserUpdate, { id }, data);
    if (response.status === 200) {
      yield put(userUpdateSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function*userDeleteSaga({ payload: { id } }) {
  console.log("Actualizando datos del USER...");
  try {
    const response = yield call(deleteUser, id );
    if (response.status === 204) {
      yield put(userDeleteSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}

function*userPermissionSaga({ payload:permission }) {
  console.log("Creando nuevo user...");
  try {
    const response = yield call(postPermissionToUser,permission);
    if (response.status === 201) {
      yield put(userPermissionSuccess(response.data));
    } else {
      yield put(userRequestFailed(response.data));
    }
  } catch (error) {
    yield put(userRequestFailed(error.response.data));
  }
}
export default function*userSaga() {
  yield takeEvery(USER_LIST,userListSaga);
  yield takeEvery(USER_FULLLIST,userFullListSaga);
  yield takeEvery(USER_FILTER,userFilterSaga);
  yield takeEvery(USER_CREATE,userCreateSaga);
  yield takeEvery(USER_UPDATE,userUpdateSaga);
  yield takeEvery(USER_DELETE,userDeleteSaga);
  yield takeEvery(USER_PERMISSION,userPermissionSaga);
}
